export class FlagsState {
  constructor(public flags: string[]) {}
}
